import * as React from 'react';

/**
 * Предзагружает lazy-компонент в idle-время браузера.
 * В Safari (нет requestIdleCallback) откладывает на следующий макротаск.
 *
 * @example
 * const Shop = lazyWithPreload(() => import('./Shop'));
 * usePreload(Shop.preload);
 */
const usePreload = (preloadFn: () => Promise<unknown>): void => {
  React.useEffect(() => {
    if (typeof requestIdleCallback !== 'undefined') {
      const handle = requestIdleCallback(() => {
        preloadFn();
      });

      return () => cancelIdleCallback(handle);
    }

    const handle = setTimeout(() => {
      preloadFn();
    }, 0);

    return () => clearTimeout(handle);
  }, []);
};

export default usePreload;
